import React, { FC, ReactElement } from 'react';
import { TikTakBoom } from '@page-components';

const TikTakBoomPage: FC = (): ReactElement => {
  return <TikTakBoom />;
};

export default TikTakBoomPage;
